import './ReactMaterialTable.css'
import React, { useState } from 'react'
import { Modal, Tooltip, Dropdown, Menu, Pagination, Tag } from 'antd'
import { useNavigate } from 'react-router-dom'
import moment from 'moment'

import { ImRadioUnchecked, ImRadioChecked2 } from 'react-icons/im'
import { TiTick } from 'react-icons/ti'
import { RiMessage2Line } from 'react-icons/ri'
import { IoMdClose } from 'react-icons/io'
import { FiEdit } from 'react-icons/fi'
import { IoWallet, } from 'react-icons/io5'
import { SiHandshake } from 'react-icons/si'
import { useSelector } from 'react-redux'
import { CgMoveRight } from 'react-icons/cg'
import { GiAlarmClock } from 'react-icons/gi'
import { MdPermContactCalendar, MdTimeline } from 'react-icons/md'
import { BsCalendar2Week } from 'react-icons/bs'
import Reminder from '../detail_design/Reminder'
import toast from 'react-hot-toast'
import Avatar from '@mui/material/Avatar';


import Texttruncate from '../TextTruncater/Texttruncate'
import MeetingModal from '../detail_design/MeetingModal'
import { light_colors_arr } from '../../helpers/Constants'


function ReactMaterialTable({ data, type, func, func1, editmeeting, selected, gotoleadcreatefunc, editDeal, selected_lead, setselected_lead_fun, setpagefuun, pagination, role_stage, setselected_assigned_lead, getreminderfun, reminder, acceptassignedlead, selected_contact, setselected_contact_func, noshare, tracker }) {

  const name = useSelector(state => state.Auth.name)
  const navigate = useNavigate()


  const [description, setdescription] = useState('')
  const [isvisible, setisvisible] = useState(false)
  const [isvisible1, setisvisible1] = useState(false)
  const [typeId, setTypeId] = useState('')
  const [meetingtype, setmeetingtype] = useState('')


  const [meeting_obj, setmeeting_obj] = useState({ type: '', typeId: '' })


  const menu = (
    <Menu>
      <div style={{ padding: '10px', maxWidth: '280px' }}>
        <h6 style={{ marginBottom: '0px', fontSize: '13px' }}>Description:</h6>
        <p style={{ fontWeight: '400', fontSize: '12px', paddingBottom: '0px' }}>{description}</p>
      </div>
    </Menu>
  );

  function gotodeal(d) {
    navigate(`/create_deal`, { state: { datas: d } })
  }

  function assigned_lead_to_deal(d) {
    let obj = {
      contact_id: d?.assigned_lead_id?.lead_id?.contact_id,
      _id: d?.assigned_lead_id?.lead_id?.id,
      lead_name: d?.assigned_lead_id?.lead_id?.lead_name,
      department_id:d?.assigned_lead_id?.lead_id?.department_id
    }
    navigate(`/create_deal`, { state: { datas: obj } })
  }

  const onReminderClick = (d) => {
    getreminderfun(d?.id ? d?.id : d)
    setTypeId(d?.id ? d?.id : d)
    setisvisible(true)
  }

  const onMeetingClick = (d) => {
    // setmeetingtype(type)
    console.log('okk', d?.lead_name)
    setTypeId(d)
    setisvisible1(true)
  }

  function onAssignClick(v) {
    if (v.accept === 'Pending') {
      toast.error('Please accept before assign!')
    }
    else if (v.accept === 'Rejected') {
      toast.error('You rejected this lead!')
    }
    else if (v.accept === 'Accepted') {
      setselected_lead_fun(v._id)
      setselected_assigned_lead(v)
    }
    else {
      toast.error('Unknown Error')
    }
  }

  const infoItems = (v) => {
    return (
      <div style={{ width: '200px', maxWidth: '200px', background: 'white', padding: '10px' }}>
        {v.remarks &&
          <>
            <h6 style={{ fontWeight: 'bold', fontSize: '13px', marginBottom: '0px' }}>Remarks</h6>
            <p style={{ marginBottom: '0px' }}>{v.remarks}</p>
          </>}
        {v.cancellation_reason &&
          <>
            <h6 style={{ fontWeight: 'bold', fontSize: '13px', marginBottom: '0px', marginTop: '2px' }}>Cancellation Reason</h6>
            <p style={{ marginBottom: '0px', fontSize: '12px' }}>{v.cancellation_reason}</p>
          </>}
      </div>
    )
  }

  if (type === 'lead') {
    return (
      <div style={{ background: 'transparent' }}>
        <MeetingModal visible={isvisible1} func={() => setisvisible1(false)} data_id={typeId} type={type} />
        <Reminder visible={isvisible} func={() => setisvisible(false)} id={typeId} type={type} reminder={reminder} getreminderfun={(v) => getreminderfun(v)} />

        {type === 'lead' &&
          <div style={{ border: '0px solid lightgray', overflowY: 'scroll' }}>

            <div className='mateial_table_header'>
              <p style={{ width: '12%', color: 'black' }}>Lead Name</p>
              <p style={{ width: '10%', marginRight: '2%' }}>Company</p>
              <p style={{ width: '22%', marginRight: '2%' }}>Email</p>
              <p style={{ width: '12%' }}>Phone</p>
              <p style={{ width: '10%' }}>Lead Status</p>
              <p style={{ width: '13%' }}>Lead Source</p>
              <p style={{ width: '12%' }}>Lead Owner</p>
              <p style={{ width: '7%' }}>Actions</p>
            </div>

            {data.map((d) => (
              <div key={d.id} className='mateial_table_body'>
                <p style={{ width: '12%', color: "#0594f2", wordBreak: 'break-word', fontWeight: '700' }} onClick={() => func(d)}>{<Texttruncate text={d?.lead_name} />}</p>
                <p style={{ width: '10%', wordBreak: 'break-word', marginRight: '2%' }}>{<Texttruncate text={d?.contact_id?.company_name} />}</p>
                <p style={{ width: '22%', wordBreak: 'break-word', marginRight: '2%' }}>{<Texttruncate text={d?.contact_id?.email} />}</p>
                <p style={{ width: '12%', wordBreak: 'break-word' }}>+91{d?.contact_id?.phone}</p>
                <p style={{ width: '10%', wordBreak: 'break-word' }}>{<Texttruncate text={d?.lead_status} />}</p>
                <p style={{ width: '13%', wordBreak: 'break-word' }}>{<Texttruncate text={d?.contact_id?.contact_source?.source_name} />}</p>
                <p style={{ width: '12%', wordBreak: 'break-word' }}>{<Texttruncate text={d?.contact_id?.contact_owner?.name} />}</p>
                <p style={{ width: '7%' }}>
                  <Tooltip title="Convert to Deal" placement='bottom'>
                    <CgMoveRight size={28} style={{ color: 'black' }} onClick={() => gotodeal(d)} />
                  </Tooltip>
                  <Tooltip title="Add Reminder" placement='bottom'>
                    <GiAlarmClock size={20} style={{ marginLeft: '10px', color: 'black' }} onClick={() => onReminderClick(d._id)} />
                  </Tooltip>
                  <Tooltip title="Add Meeting" placement='bottom' style={{ marginLeft: '5px' }}>
                    <BsCalendar2Week size={15} onClick={() => onMeetingClick(d)} />
                  </Tooltip>
                </p>
              </div>
            ))}

            <div style={{ width: '100%', display: 'flex', justifyContent: 'center', margin: '40px auto' }}>
              {pagination?.total > 20 &&
                <Pagination defaultCurrent={1} size="small" total={pagination.total} onChange={(v) => setpagefuun(v)} showSizeChanger pageSize={20} />
              }
            </div>

          </div>
        }
      </div>
    )
  } else if (type === 'assign_lead') {
    return (<div style={{ background: 'transparent' }}>
      <MeetingModal visible={isvisible1} func={() => setisvisible1(false)} data_id={typeId} type={type} />
      <Reminder visible={isvisible} func={() => setisvisible(false)} id={typeId} type={type} reminder={reminder} getreminderfun={(v) => getreminderfun(v)} />
      <div style={{ border: '0px solid lightgray', overflowY: 'scroll' }}>
        <div className='mateial_table_header'>
          <p style={{ width: '4%' }}></p>
          <p style={{ width: '10%', color: 'black' }}>Lead Name</p>
          <p style={{ width: '12%', marginRight: '2%' }}>Company</p>
          <p style={{ width: '16%', marginRight: '2%' }}>Email</p>
          <p style={{ width: '10%', marginRight: '1%' }}>Phone</p>
          <p style={{ width: '13%', marginRight: '1%' }}>Lead Status</p>
          <p style={{ width: '14%', marginRight: '1%' }}>Lead Source</p>
          <p style={{ width: '14%' }}>Lead Owner</p>
          <p style={{ width: '7%' }}>Actions</p>
        </div>

        {data.map((d, i) => (
          <div key={i} className={selected_lead !== d._id ? 'mateial_table_body' : 'mateial_table_body_active'}>
            {selected_lead !== d._id ? <ImRadioUnchecked size={14} style={{ width: '4%', marginTop: '-1px', color: '#c2c2c2', cursor: d.isConverted ? 'not-allowed' : 'pointer' }} onClick={() => !d.isConverted && setselected_lead_fun(d._id)} /> :
              <ImRadioChecked2 size={14} style={{ width: '4%', marginTop: '0px', marginLeft: '0px', color: '#0073ba' }} onClick={() => setselected_lead_fun('')} />}
            <p style={{ width: '10%', color: "#0594f2", wordBreak: 'break-word', fontWeight: '700' }} onClick={() => func(d)}>{<Texttruncate text={d?.lead_name} />}</p>
            <p style={{ width: '12%', wordBreak: 'break-word', marginRight: '2%' }}>{<Texttruncate text={d?.contact_id?.company_name} />}</p>
            <p style={{ width: '16%', wordBreak: 'break-word', marginRight: '2%' }}>{<Texttruncate text={d?.contact_id?.email} />}</p>
            <p style={{ width: '10%', wordBreak: 'break-word', marginRight: '1%' }}>{d?.contact_id?.phone}</p>
            <p style={{ width: '13%', wordBreak: 'break-word', marginRight: '1%' }}>{<Texttruncate text={d?.lead_status?.split(' ')[0]} />}</p>
            <p style={{ width: '14%', wordBreak: 'break-word', marginRight: '1%' }}>{<Texttruncate text={d?.contact_id?.contact_source?.source_name} />}</p>
            <p style={{ width: '14%', wordBreak: 'break-word' }}>{<Texttruncate text={d?.lead_owner?.name} />}</p>
            <p style={{ width: '7%', display: 'flex', justifyContent: 'space-between' }}>
              <Tooltip title="Convert to Deal" placement='bottom'>
                <CgMoveRight size={28} onClick={() => !d.isConverted && gotodeal(d)} style={{ ...d.isConverted && { color: '#d4d4d4' } }} />
              </Tooltip>
              <Tooltip title="Add Reminder" placement='bottom'>
                <GiAlarmClock size={20} onClick={() => !d.isConverted && onReminderClick(d._id)} style={{ ...d.isConverted && { color: '#d4d4d4' } }} />
              </Tooltip>
              <Tooltip title="Add Meeting" placement='bottom' >
                <BsCalendar2Week size={15} onClick={() => onMeetingClick(d)} style={{ marginLeft: '10px' }} />
              </Tooltip>
            </p>
          </div>
        ))}

        <div style={{ width: '100%', display: 'flex', justifyContent: 'center', margin: '40px auto' }}>
          {pagination?.total > 20 &&
            <Pagination defaultCurrent={1} size="small" total={pagination.total} onChange={(v) => setpagefuun(v)} showSizeChanger pageSize={20} />
          }
        </div>
      </div>
    </div>
    )
  } else if (type === 'assign_lead1') {
    return (<div style={{ background: 'transparent' }}>
      <MeetingModal visible={isvisible1} func={() => setisvisible1(false)} data_id={typeId} type={type} />
      <Reminder visible={isvisible} func={() => setisvisible(false)} id={typeId} type={type} reminder={reminder} getreminderfun={(v) => getreminderfun(v)} />
      <div style={{ border: '0px solid lightgray', }}>
        <div className='mateial_table_header'>
          {!noshare &&
            <p style={{ width: '4%', maxWidth: '4%' }}></p>}
          <p style={{ width: '10%', maxWidth: '10%', color: 'black' }}>Lead Name</p>
          <p style={{ width: '10%', maxWidth: '10%' }}>Company</p>
          <p style={{ width: '16%', maxWidth: '16%' }}>Email</p>
          <p style={{ width: '10%', maxWidth: '10%' }}>Phone</p>
          <p style={{ width: '10%', maxWidth: '10%' }}>Assigned By</p>
          <p style={{ width: '10%', maxWidth: '10%' }}>Assigned Date</p>
          <p style={{ width: '12%', maxWidth: '12%' }}>Accept status</p>
          <p style={{ width: '10%', maxWidth: '10%' }}>Info</p>
          <p style={{ width: '8%', maxWidth: '8%' }}>Actions</p>
        </div>
        {data.map((d, i) => (
          <div key={i} className={selected_lead !== d._id ? 'mateial_table_body' : 'mateial_table_body_active'}>
            {!noshare &&
              <>
                {selected_lead !== d._id ? <ImRadioUnchecked size={14} style={{ minWidth: '4%', maxWidth: '4%', marginTop: '0px', color: '#c2c2c2', cursor: d?.assigned_lead_id?.lead_id?.isConverted ? 'not-allowed' : 'pointer' }} onClick={() => !d?.assigned_lead_id?.lead_id?.isConverted && onAssignClick(d)} /> :
                  <ImRadioChecked2 size={14} style={{ minWidth: '4%', maxWidth: '4%', marginTop: '0px', color: '#0073BA' }} onClick={() => setselected_lead_fun('')} />}
              </>}
            {(d.accept === 'Pending') ?
              <p style={{ width: '10%', maxWidth: '10%', color: "black", wordBreak: 'break-word', fontWeight: '700', cursor: 'pointer' }} >{d?.assigned_lead_id?.lead_id?.lead_name?.slice(0, 15)}</p> :
              <p style={{ width: '10%', maxWidth: '10%', color: "#0594F2", wordBreak: 'break-word', fontWeight: '700', cursor: d.accept === 'Rejected' ? 'not-allowed' : 'pointer' }} onClick={() => (d.accept === 'Accepted' || d.accept === 'Pending') && func(d?.assigned_lead_id?.lead_id?.id)}>{d?.assigned_lead_id?.lead_id?.lead_name?.slice(0, 15)}</p>}
            <p style={{ width: '10%', maxWidth: '10%', wordBreak: 'break-word' }}>{d?.assigned_lead_id?.lead_id?.contact_id?.company_name?.slice(0, 15)}</p>
            <p style={{ width: '16%', maxWidth: '16%', wordBreak: 'break-word' }}>{d?.assigned_lead_id?.lead_id?.contact_id?.email?.slice(0, 15)}</p>
            <p style={{ width: '10%', maxWidth: '10%', wordBreak: 'break-word', }}>{d?.assigned_lead_id?.lead_id?.contact_id?.phone}</p>
            <p style={{ width: '10%', maxWidth: '10%', wordBreak: 'break-word', fontSize: '13px', marginLeft: '4px' }}>{d?.assigned_by?.name?.slice(0, 15)}</p>
            <p style={{ width: '10%', maxWidth: '10%', wordBreak: 'break-word', fontSize: '13px', marginLeft: '4px' }}>{moment(d?.createdAt).format('LL')}</p>
            <p style={{ width: '12%', maxWidth: '12%', fontSize: '13px', }}><Tag color={(d.accept === 'Pending' && '#108ee9') || (d.accept === 'Accepted' && '#87d068') || (d.accept === 'Rejected' && '#f50')}>{d?.accept?.slice(0, 15)}</Tag></p>
            <p style={{ width: '10%', maxWidth: '10%', wordBreak: 'break-word', fontSize: '13px', marginLeft: '-10px' }}>

              <Dropdown overlay={() => infoItems(d)} placement="bottomLeft">
                <RiMessage2Line size={22} />
              </Dropdown>
            </p>

            {
              (d.accept === 'Pending') &&
              <p style={{ maxWidth: '8%', display: 'flex' }}>
                <Tooltip title="Accept" placement='bottom'>
                  <TiTick size={22} style={{ color: 'black' }} onClick={() => Modal.confirm({
                    title: 'Confirmation',
                    content: 'By clicking on approve you have access to this lead',
                    okText: 'Approve',
                    cancelText: 'Cancel',
                    onOk: () => acceptassignedlead(d, 1),
                    onCancel: ''

                  }

                  )} />
                </Tooltip>
                <Tooltip title="Dont Accept" placement='bottom'>
                  <IoMdClose size={20} style={{ marginLeft: '10px', color: 'black' }} onClick={() => acceptassignedlead(d, 2)} />
                </Tooltip>
              </p>
            }
            {
              (d.accept === 'Accepted') &&
              <p style={{ maxWidth: '8%', display: 'flex', justifyContent: 'space-between' }}>
                <Tooltip title="Convert to Deal" placement='bottom'>
                  <CgMoveRight size={28} onClick={() => !d?.assigned_lead_id?.lead_id?.isConverted && assigned_lead_to_deal(d)} style={{ ...d?.assigned_lead_id?.lead_id?.isConverted ? { color: '#d4d4d4', cursor: 'not-allowed' } : { color: 'black' } }} />
                </Tooltip>
                <Tooltip title="Add Reminder" placement='bottom'>
                  <GiAlarmClock size={20} onClick={() => !d?.assigned_lead_id?.lead_id?.isConverted && onReminderClick(d?.assigned_lead_id?.lead_id?.id)} style={{ ...d?.assigned_lead_id?.lead_id?.isConverted ? { color: '#d4d4d4', cursor: 'not-allowed', marginLeft: '10px' } : { marginLeft: '10px', color: 'black' } }} />
                </Tooltip>
                <Tooltip title="Add Meeting" placement='bottom' >
                  <BsCalendar2Week size={15} onClick={() => onMeetingClick(d)} style={{ marginLeft: '15px' }} />
                </Tooltip>
              </p>
            }


          </div>
        ))}
        <div style={{ width: '100%', display: 'flex', justifyContent: 'center', margin: '40px auto' }}>
          {pagination.total > 20 &&
            <Pagination defaultCurrent={1} size="small" total={pagination.total} onChange={(v) => setpagefuun(v)} showSizeChanger pageSize={20} />
          }
        </div>
      </div>
    </div>)
  } else if (type === 'assign_lead2') {
    return (
      <div style={{ background: 'transparent' }}>
        <Reminder visible={isvisible} func={() => setisvisible(false)} id={typeId} type={type} reminder={reminder} getreminderfun={(v) => getreminderfun(v)} />
        <>
          <div style={{ border: '0px solid lightgray', }}>
            <div className='mateial_table_header'>
              <p style={{ minWidth: '12%', color: 'black' }}>Lead Name</p>
              <p style={{ minWidth: '10%', marginRight: '0.5%' }}>Company</p>
              <p style={{ minWidth: '18%', marginRight: '0.5%' }}>Email</p>
              <p style={{ minWidth: '12%' }}>Phone</p>
              <p style={{ minWidth: '10%' }}>Assigned To</p>
              <p style={{ minWidth: '12%', marginRight: '0.5%' }}>Assigned Date</p>
              <p style={{ minWidth: '10%' }}>Accept status</p>
              <p style={{ minWidth: '5%' }}>Info</p>
              <p style={{ minWidth: '5%' }}>Track Status</p>
            </div>
            {data.map((d) => (
              <div key={d._id} className={selected_lead !== d._id ? 'mateial_table_body' : 'mateial_table_body_active'}>
                <p style={{ minWidth: '12%', maxWidth: '12%', color: d.status ? "#0594F2" : "black", wordBreak: 'break-word', fontWeight: '700' }} onClick={() => func(d?.assigned_lead_id?.lead_id?.id)}>{d?.assigned_lead_id?.lead_id?.lead_name?.slice(0, 15)}</p>
                <p style={{ minWidth: '10%', wordBreak: 'break-word', marginRight: '0.5%' }}>{d?.assigned_lead_id?.lead_id?.contact_id?.company_name?.slice(0, 15)}</p>
                <p style={{ minWidth: '18%', wordBreak: 'break-word', marginRight: '0.5%' }}>{d?.assigned_lead_id?.lead_id?.contact_id?.email?.slice(0, 15)}</p>
                <p style={{ minWidth: '12%', wordBreak: 'break-word', }}>{d?.assigned_lead_id?.lead_id?.contact_id?.phone}</p>
                <p style={{ minWidth: '10%', wordBreak: 'break-word' }}>{d?.user_id?.name?.slice(0, 15)}</p>
                <p style={{ minWidth: '12%', wordBreak: 'break-word', marginRight: '0.5%' }}>{moment(d?.createdAt).format('LL')}</p>
                <p style={{ minWidth: '10%' }}>{<Tag color={(d.accept === 'Pending' && '#108ee9') || (d.accept === 'Accepted' && '#87d068') || (d.accept === 'Rejected' && '#f50')}>{d?.accept?.slice(0, 15)}</Tag>}</p>
                <p style={{ minWidth: '5%', maxWidth: '5%' }}>
                  <Dropdown style={{ minWidth: '5%' }} overlay={() => infoItems(d)} placement="bottomLeft">
                    <RiMessage2Line size={22} />
                  </Dropdown>
                </p>
                <p style={{ minWidth: '5%', maxWidth: '5%', alignItems: 'center', textAlign: 'center' }} onClick={() => tracker(d)}>
                  <MdTimeline size={24} style={{ color: 'black', marginLeft: '0px' }} />
                </p>
              </div>
            ))}
            <div style={{ minWidth: '100%', display: 'flex', justifyContent: 'center', margin: '40px auto' }}>
              {pagination.total > 20 &&
                <Pagination defaultCurrent={1} size="small" total={pagination.total} onChange={(v) => setpagefuun(v)} showSizeChanger pageSize={20} />
              }
            </div>
          </div>
        </>
      </div>
    )
  } else if (type === 'deal') {
    return (
      <div style={{ background: 'transparent' }}>
        <MeetingModal visible={isvisible1} func={() => setisvisible1(false)} data_id={typeId} type={type} />
        <Reminder visible={isvisible} func={() => setisvisible(false)} id={typeId} type={type} reminder={reminder} getreminderfun={(v) => getreminderfun(v)} />
        <div style={{ border: '0px solid lightgray', }}>
          <div className='mateial_table_header'>
            <p style={{ width: '12%' }}>Deal Name</p>
            <p style={{ width: '10%' }}>Company</p>
            <p style={{ width: '15%' }}>Stage</p>
            <p style={{ width: '15%' }}>Closing Date</p>
            <p style={{ width: '15%' }}>Phone</p>
            <p style={{ width: '22%', marginRight: '1%' }}>Email</p>
            <p style={{ width: '12%' }}>Deal Owner</p>
            <p style={{ width: '10%' }}>Actions</p>
          </div>

          {data.map((d) => (
            <div key={d.id} className='mateial_table_body'>
              <p style={{ width: '12%', color: "#0594f2", cursor: 'pointer', fontWeight: '700', wordBreak: 'break-word' }}
                onClick={() => func(d)}>{<Texttruncate text={d?.deal_name} />}</p>
              <p style={{ width: '10%', wordBreak: 'break-word' }}>{<Texttruncate text={d?.lead_id?.contact_id?.company_name} />}</p>
              <p style={{ width: '15%', wordBreak: 'break-word' }}>{<Texttruncate text={d?.deal_stage} />}</p>
              <p style={{ width: '15%', wordBreak: 'break-word' }}>{moment(d?.closing_date).format('LL')}</p>
              <p style={{ width: '15%', wordBreak: 'break-word' }}>{d?.lead_id?.contact_id?.phone}</p>
              <p style={{ width: '22%', wordBreak: 'break-word', marginRight: '1%' }}>{<Texttruncate text={d?.lead_id?.contact_id?.email} />}</p>
              <p style={{ width: '12%', wordBreak: 'break-word' }}>{<Texttruncate text={d?.deal_owner?.name} />}</p>
              <p style={{ width: '10%', wordBreak: 'break-word' }}>
                <Tooltip title="Add Reminder" placement='bottom'>
                  <GiAlarmClock size={22} style={{ marginRight: '10px', color: 'black' }} onClick={() => onReminderClick(d?.id || d?._id)} />
                </Tooltip>
                <Tooltip title="Edit Deal" placement='bottom'>
                  <FiEdit size={18} style={{ marginRight: '10px', color: 'black' }} onClick={() => editDeal(d?.id)} />
                </Tooltip>
                <Tooltip title="Add Meeting" placement='bottom' >
                  <BsCalendar2Week size={15} onClick={() => onMeetingClick(d)} style={{ marginLeft: '3px' }} />
                </Tooltip>
              </p>
            </div>
          ))}

          <div style={{ width: '100%', display: 'flex', justifyContent: 'center', margin: '40px auto' }}>
            {pagination?.total > 20 &&
              <Pagination defaultCurrent={1} size="small" total={pagination?.total} onChange={(v) => setpagefuun(v)} showSizeChanger pageSize={20} />
            }
          </div>

        </div>

      </div>
    )
  } else if (type === 'contact') {
    return (
      <div style={{ background: 'transparent' }}>
        <MeetingModal visible={isvisible1} func={() => setisvisible1(false)} data_id={typeId} type={type} />
        <Reminder visible={isvisible} func={() => setisvisible(false)} id={typeId} type={type} reminder={reminder} getreminderfun={(v) => getreminderfun(v)} />
        <div style={{ border: '0px solid lightgray', }}>
          <div className='mateial_table_header'>
            <p style={{ width: '2%' }}></p>
            <p style={{ width: '10%', color: 'black', paddingLeft: '0.5%' }}>Company </p>
            <p style={{ width: '12%', paddingLeft: '0.5%' }}>Contact Name</p>
            <p style={{ width: '12%' }}>Phone</p>
            <p style={{ width: '20%' }}>Email</p>
            <p style={{ width: '12%' }}>Designation</p>
            <p style={{ width: '12%' }}>Contact Source</p>
            <p style={{ width: '10%' }}>Contact Status</p>
            <p style={{ width: '9%' }}>Actions</p>
          </div>
          {data.map((d) => (
            // style={{background:d?.isConverted ? '#ededff':'white'}}
            <div key={d.id} className={selected_contact !== (d.id ? d.id : d._id) ? 'mateial_table_body' : 'mateial_table_body_active'} >
              {selected_contact !== (d.id ? d.id : d._id) ? <ImRadioUnchecked size={14} style={{ width: '2%', marginTop: '-1px', color: '#c2c2c2' }} onClick={() => setselected_contact_func(d.id ? d.id : d._id)} /> :
                <ImRadioChecked2 size={14} style={{ width: '2%', marginTop: '0px', marginLeft: '0px', color: '#0073ba' }} onClick={() => setselected_contact_func('')} />}
              <p style={{ width: '10%', fontWeight: '700', color: "#0594f2", wordBreak: 'break-word', paddingLeft: '0.5%' }} onClick={() => func(d)}>{d?.company_name?.slice(0, 12)}{d?.company_name?.length > 12 && '...'}</p>
              <p style={{ width: '12%', wordBreak: 'break-word', paddingLeft: '0.5%' }}>{<Texttruncate text={d?.contact_name} />}</p>
              <p style={{ width: '12%', wordBreak: 'break-word' }}>{d?.phone}</p>
              <p style={{ width: '20%', wordBreak: 'break-word' }}>{<Texttruncate text={d?.email} />}</p>
              <p style={{ width: '12%', wordBreak: 'break-word' }}>{<Texttruncate text={d?.designation} />}</p>
              <p style={{ width: '12%', wordBreak: 'break-word' }}>{<Texttruncate text={d?.contact_source?.source_name} />}</p>
              <p style={{ width: '10%', wordBreak: 'break-word' }}>{<Texttruncate text={d?.status} />}</p>
              <p style={{ width: '9%' }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Tooltip title="Convert to Lead" placement='bottom'>
                    <CgMoveRight size={26} style={{ marginRight: '5px', color: 'black' }} onClick={() => gotoleadcreatefunc(d)} />
                  </Tooltip>
                  <Tooltip title="Add Reminder" placement='bottom'>
                    <GiAlarmClock size={19} style={{ marginRight: '9px', color: 'black' }} onClick={() => onReminderClick(d)} />
                  </Tooltip>
                  <Tooltip title="Add Meeting" placement='bottom' style={{ marginLeft: '15px' }}>
                    <BsCalendar2Week size={15} onClick={() => onMeetingClick(d)} />
                  </Tooltip>

                  <Avatar  sx={{bgcolor: light_colors_arr[Math.floor(Math.random() * light_colors_arr?.length) + 1],width: 20, height: 20,fontSize:'10px',color:'black',fontWeight:'800',marginLeft:'10px'}}>{d?.conversion_count}</Avatar>

                </div>
              </p>
            </div>
          ))}

          <div style={{ width: '100%', display: 'flex', justifyContent: 'center', margin: '40px auto' }}>
            {pagination?.total > 20 &&
              <Pagination defaultCurrent={1} size="small" total={pagination?.total} onChange={(v) => setpagefuun(v)} showSizeChanger pageSizeOptions={[20]} pageSize={20} />
            }
          </div>
        </div>
      </div>
    )
  } else if (type === 'Referred by me') {
    return (
      <div style={{ background: 'transparent' }}>
        <Reminder visible={isvisible} func={() => setisvisible(false)} id={typeId} type={type} reminder={reminder} getreminderfun={(v) => getreminderfun(v)} />
        <div style={{ border: '0px solid lightgray', }}>
          <div className='mateial_table_header'>
            <p style={{ width: '2%' }}></p>
            <p style={{ width: '14%', color: 'black' }}>Company </p>
            <p style={{ width: '12%', paddingLeft: '0.5%' }}>Contact Name</p>
            <p style={{ width: '12%' }}>Phone</p>
            <p style={{ width: '22%' }}>Email</p>
            <p style={{ width: '10%' }}>Contact Status</p>
            <p style={{ width: '10%' }}>Contact Owner</p>
            <p style={{ width: '17%' }}>Referred Department</p>
            <p style={{ width: '12%' }}>Referred Person</p>
            <p style={{ width: '2%' }}></p>
          </div>
          {data.map((d) => (
            <div key={!d.id ? d._id : d.id} className={'mateial_table_body'} >
              <p style={{ width: '2%' }}></p>
              <p style={{ width: '14%', fontWeight: '700', color: "#0594f2", wordBreak: 'break-word' }} onClick={() => func1(d?.contact_id?.id)}>{d?.contact_id?.company_name?.slice(0, 12)}{d?.contact_id?.company_name?.length > 12 && '...'}</p>
              <p style={{ width: '12%', wordBreak: 'break-word', paddingLeft: '0.5%' }}>{<Texttruncate text={d?.contact_id?.contact_name} />}</p>
              <p style={{ width: '12%', wordBreak: 'break-word', fontWeight: 'bold' }}>{<Texttruncate text={d?.contact_id?.phone} />}</p>
              <p style={{ width: '22%', wordBreak: 'break-word' }}>{<Texttruncate text={d?.contact_id?.email} />}</p>
              <p style={{ width: '10%', wordBreak: 'break-word' }}><Tag color="magenta">{<Texttruncate text={d?.contact_id?.status} />}</Tag></p>
              <p style={{ width: '10%', wordBreak: 'break-word' }}><Tag color="magenta">{<Texttruncate text={d?.contact_id?.contact_owner?.name} />}</Tag></p>
              <p style={{ width: '17%', wordBreak: 'break-word' }}><Tag color="green">{<Texttruncate text={d?.department_id?.department_name} />}</Tag></p>
              <p style={{ width: '12%', wordBreak: 'break-word' }}><Tag color="cyan">{<Texttruncate text={d?.referred_to?.name} />}</Tag></p>
              <p style={{ width: '2%' }}>
              <Avatar  sx={{bgcolor: light_colors_arr[Math.floor(Math.random() * light_colors_arr?.length) + 1],width: 20, height: 20,fontSize:'10px',color:'black',fontWeight:'800',marginLeft:'10px'}}>{d?.contact_id?.conversion_count}</Avatar>
              </p>
            </div>
          ))}

          <div style={{ width: '100%', display: 'flex', justifyContent: 'center', margin: '40px auto' }}>
            {pagination?.total > 20 &&
              <Pagination defaultCurrent={1} size="small" total={pagination?.total} onChange={(v) => setpagefuun(v)} showSizeChanger pageSizeOptions={[20]} pageSize={20} />
            }
          </div>
        </div>

      </div>
    )
  } else if (type === 'Referred To me') {
    return (
      <div style={{ background: 'transparent' }}>
        <MeetingModal visible={isvisible1} func={() => setisvisible1(false)} data_id={typeId} type={type} />
        <Reminder visible={isvisible} func={() => setisvisible(false)} id={typeId} type={'contact'} reminder={reminder} getreminderfun={(v) => getreminderfun(v)} />
        <div style={{ border: '0px solid lightgray', }}>
          <div className='mateial_table_header'>
            <p style={{ width: '2%' }}></p>
            <p style={{ width: '10%', minWidth: '10%', maxWidth: '10%', color: 'black' }}>Company </p>
            <p style={{ width: '10%', paddingLeft: '0.5%' }}>Contact Name</p>
            <p style={{ width: '10%' }}>Phone</p>
            <p style={{ width: '16%' }}>Email</p>
            <p style={{ width: '16%' }}>Contact Status</p>
            <p style={{ width: '12%' }}>Contact owner</p>
            <p style={{ width: '12%' }}>Transferred By</p>
            <p style={{ width: '10%' }}>Actions</p>
          </div>
          {data.map((d) => (
            <div key={d._id ? d._id : d.id} className={selected_contact !== d._id ? 'mateial_table_body' : 'mateial_table_body_active'}>
              <p style={{ width: '2%', }}>
                {selected_contact !== d._id ? <ImRadioUnchecked size={14} style={{ marginTop: '-1px', color: '#c2c2c2' }} onClick={() => setselected_contact_func(d._id, d?.contact_id?.id)} /> :
                  <ImRadioChecked2 size={14} style={{ marginTop: '0px', marginLeft: '0px', color: '#0073ba' }} onClick={() => setselected_contact_func('')} />}
              </p>
              <p style={{ minWidth: '10%', maxWidth: '10%', fontWeight: '700', color: "#0594f2", wordBreak: 'break-word' }} onClick={() => func1(d?.contact_id?.id)}>{d?.contact_id?.company_name?.slice(0, 12)}{d?.contact_id?.company_name?.length > 12 && '...'}</p>
              <p style={{ minWidth: '10%', maxWidth: '10%', wordBreak: 'break-word', paddingLeft: '0.5%' }}>{<Texttruncate text={d?.contact_id?.contact_name} />}</p>
              <p style={{ minWidth: '10%', maxWidth: '10%', wordBreak: 'break-word', fontWeight: '800' }}>{d?.contact_id?.phone}</p>
              <p style={{ minWidth: '16%', maxWidth: '16%', wordBreak: 'break-word' }}>{<Texttruncate text={d?.contact_id?.email} />}</p>
              <p style={{ minWidth: '16%', maxWidth: '16%' }}><Tag color="green">{<Texttruncate text={d?.contact_id?.status} />}</Tag></p>
              <p style={{ minWidth: '12%', maxWidth: '12%' }}><Tag color="red">{<Texttruncate text={d?.contact_id?.contact_owner?.name} />}</Tag></p>
              <p style={{ minWidth: '12%', maxWidth: '12%', wordBreak: 'break-word' }}><Tag color="cyan">{<Texttruncate text={d?.referred_by?.name} />}</Tag></p>
              <p style={{ maxWidth: '10%', minWidth: '10%', width: '10%',display:'flex',justifyItems:'flex-start' }}>


                  <Tooltip title="Convert to Lead" placement='bottom'>
                    <CgMoveRight size={28} style={{ marginRight: '6px', color: 'black' }} onClick={() => gotoleadcreatefunc(d?.contact_id)} />
                  </Tooltip>
                  <Tooltip title="Add Reminder" placement='bottom'>
                    <GiAlarmClock size={20} style={{ marginRight: '10px', color: 'black' }} onClick={() => onReminderClick(d?.contact_id?.id)} />
                  </Tooltip>
                  <Tooltip title="Add Meeting" placement='bottom' style={{ marginLeft: '5px' }}>
                    <BsCalendar2Week size={15} onClick={() => onMeetingClick(d)} />
                  </Tooltip>
              <Avatar  sx={{bgcolor: light_colors_arr[Math.floor(Math.random() * light_colors_arr?.length) + 1],width: 20, height: 20,fontSize:'10px',color:'black',fontWeight:'800',marginLeft:'10px'}}>{d?.contact_id?.conversion_count}</Avatar>

              </p>
            </div>
          ))}

          <div style={{ width: '100%', display: 'flex', justifyContent: 'center', margin: '40px auto' }}>
            {pagination?.total > 20 &&
              <Pagination defaultCurrent={1} size="small" total={pagination?.total} onChange={(v) => setpagefuun(v)} showSizeChanger pageSizeOptions={[20]} pageSize={20} />
            }
          </div>
        </div>

      </div>
    )
  } else if (type === 'meeting') {
    return (
      <div style={{ background: 'transparent' }}>
        <Reminder visible={isvisible} func={() => setisvisible(false)} id={typeId} type={type} reminder={reminder} getreminderfun={(v) => getreminderfun(v)} />
        <div style={{ border: '0px solid lightgray', }}>
          <div className='mateial_table_header'>
            <p style={{ width: '15%', fontWeight: '800', color: 'black' }}>Title</p>
            <p style={{ width: '15%' }}>Date</p>
            <p style={{ width: '15%' }}>Time</p>
            <p style={{ width: '15%' }}>Related To</p>
            <p style={{ width: '15%' }}>Contact Name</p>
            <p style={{ width: '15%' }}>Location</p>
            <p style={{ width: '12%' }}>Host</p>
            <p style={{ width: '10%' }}>Actions</p>
          </div>
          {data?.map((d, i) => (
            <div key={d.id} className={selected === d.id ? 'mateial_table_body_active' : 'mateial_table_body'}>
              <Dropdown arrow overlay={menu} onClick={() => setdescription(d.description)} trigger={['click']}><p style={{ width: '15%', color: "#3886c4", fontWeight: '600' }}>{<Texttruncate text={d.title} />}</p></Dropdown>
              <p style={{ width: '15%', fontWeight: '500', wordBreak: 'break-word' }}>{moment(d.date_time).format('LL')}</p>
              <p style={{ width: '15%', wordBreak: 'break-word' }}>{moment(d.date_time).format('LT')}</p>
              <p style={{ width: '15%', fontWeight: '600', wordBreak: 'break-word', paddingLeft: '4px' }}>{<Texttruncate text={d.related_to} />}</p>
              <p style={{ width: '15%', fontWeight: '600', wordBreak: 'break-word' }}>{d.related_to === 'Lead' && <SiHandshake size={16} style={{ marginRight: '10px', color: '#ff9a3b' }} />} {d.related_to === 'Lead' && <Texttruncate text={d?.contact_name?.lead_name} />} {d.related_to === 'Deal' && <IoWallet size={18} style={{ marginRight: '10px', color: '#31d45f' }} />} {d.related_to === 'Deal' && <Texttruncate text={d?.contact_name?.deal_name} />} {d.related_to === 'Contact' && <MdPermContactCalendar size={18} style={{ marginRight: '5px', color: '#3badff' }} />} {d.related_to === 'Contact' && <Texttruncate text={d?.contact_name?.contact_name} />} </p>
              <p style={{ width: '15%', fontWeight: '600', wordBreak: 'break-word', paddingLeft: '4px' }}>{<Texttruncate text={d.location} />}</p>
              <p style={{ width: '12%', wordBreak: 'break-word', paddingLeft: '4px' }}>{<Texttruncate text={name?.split(' ')[0]} />}</p>
              <p style={{ width: '10%', marginLeft: '5px', wordBreak: 'break-word' }}><GiAlarmClock size={20} style={{ marginRight: '10px', color: 'black' }} onClick={() => onReminderClick(d.id)} /><FiEdit size={18} style={{ color: 'black' }} onClick={() => editmeeting(d)} /> </p>
            </div>))}


          <div style={{ width: '100%', display: 'flex', justifyContent: 'center', margin: '40px auto' }}>
            {pagination?.total > 20 &&
              <Pagination defaultCurrent={1} size="small" total={pagination?.total} onChange={(v) => setpagefuun(v)} showSizeChanger pageSize={20} />
            }
          </div>

        </div>

      </div>
    )
  } else {
    return null
  }
}

export default ReactMaterialTable
